import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-slate-800 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-152" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-153" data-mp="2vppn17ywe6cr">
        <div className="text-center" data-id="element-154" data-mp="39hvywhv0pr6e">
          <SectionHeading id="problem-title" data-id="element-155" data-mp="39guq6k1h5gru">Ti suona <span className="text-orange-400" data-id="element-156" data-mp="39jqmy51l5zep">familiare?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-slate-300" data-id="element-157" data-mp="35g10bl4h1rwb">
            La geologia fa parte del tuo programma, ma trasformarla in lezioni chiare e coinvolgenti richiede tempo.
            Rocce, placche, terremoti, strati e tempo geologico sono concetti che gli studenti faticano a visualizzare, e tu
            devi spiegarli senza materiali adeguati.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-158" data-mp="1k52bc60tklhq">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-white" data-id="element-159" data-mp="x4s1mwtqtab1">
            <AlertTriangleIcon className="h-5 w-5 text-amber-400" aria-hidden="true" data-id="element-160" data-mp="122jrllatumcl" />
            Il vero problema:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-161" data-mp="170v1tx51ayvc">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-slate-300" data-id="element-162" data-mp="1c33vywtn86z1">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-orange-400" aria-hidden="true" data-id="element-163" data-mp="1g2coxzgv00tj" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-164" data-mp="3htz7rdqlkpex">
          <p className="mx-auto max-w-2xl text-lg font-bold text-white" data-id="element-165" data-mp="3hv0s68ti6o9b">
            Non ti servono altre informazioni sparse.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-amber-400 sm:text-3xl" data-id="element-166" data-mp="k1pdrn8jbqkl">Ti serve un sistema organizzato e pronto per la classe.</p>
        </div>
      </div>
    </section>;
}